module.exports = __webpack_public_path__ + "static/img/h-banner_03.5df0642.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h-banner_03.png
// module id = 16
// module chunks = 1